export class AplicacionUserFrontModel {

    cedula: string;
    userName: string;
    appId: number;
    appIdOld: string;

    constructor() { }
}